import React, { useState } from 'react';
import CheckboxGroup from 'commons/components/CheckboxGroup';
import classnames from 'classnames';
import MetsIcon from '../MetsIcon';
import InputField from '../FormFields/InputField';
import './styles.scss';

interface FilteredCheckListItemType {
    disabled: boolean,
    itemData: string,
    label: string,
    selected: boolean,
    value: string,
    visible: boolean
}

interface FilteredCheckListProps {
    className?: string,
    id?: string,
    itemIdPrefix?: string,
    items: [FilteredCheckListItemType],
    onCheckboxChange: (e: React.ChangeEvent<HTMLInputElement>) => void,
    searchPlaceholder?: string,
    selectorTitle?: string,
    selectAllLabel?: string,
}

function FilteredCheckList(props: FilteredCheckListProps) {
    
    const widgetClassName = classnames("filtered-checklist", props.className);
    const [checkListItems, setCheckListItems] = useState(props.items);

    return (

        <div className={widgetClassName} id={props.id} data-testid={props.id}>

            <div className="filter-input">
                <MetsIcon className="search-icon" name="svg_search" />
                <InputField
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {

                        const checkListCopy = Object.assign([{}], checkListItems);
                        const filterText = e.target.value.toLowerCase();

                        // set visibility based on presence of filterText in label
                        checkListCopy.forEach((item: FilteredCheckListItemType) => {
                            item.visible = item.label.toLowerCase().includes(filterText);
                        });                        
                            
                        setCheckListItems(checkListCopy);
                    }}
                    placeholder={props.searchPlaceholder}
                    type="search"
                />
            </div>

            <div className="list-title">
                <div className="title">{props.selectorTitle}</div>
                <div className="select-all">
                    <a href="#" onClick={(e: any) => {

                        const emptyTypedList: FilteredCheckListItemType[] = [];
                        const checkListCopy = Object.assign(emptyTypedList, checkListItems);

                        // are we selecting or unselecting?
                        const toggleValue = (checkListCopy.filter((item) => !item.disabled && !item.selected).length > 0);

                        // un/select all (only select All if they are enabled)
                        checkListCopy.filter((item) => !item.disabled || !toggleValue).forEach((item: FilteredCheckListItemType) => {
                            item.selected = toggleValue;
                        });                        
                            
                        setCheckListItems(checkListCopy);
                        
                        props.onCheckboxChange(e);

                    }}>{props.selectAllLabel}</a>
                </div>                
            </div>

            <div className="checklist"> 
                <CheckboxGroup
                    checkboxIdPrefix={props.itemIdPrefix || ''}
                    layout="list"
                    disabled={false}
                    readOnly={false}
                    items={checkListItems}
                    id={props.id || ''}
                    name={props.id || ''}
                    onChange={(e) => props.onCheckboxChange(e)} 
                />
            </div>

        </div>

    );
}


export default FilteredCheckList;